module.exports = __webpack_public_path__ + "static/media/tiles.a310acf4.png";